import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../utils/updateObject";
import { isMobileDevice } from "../../utils/deviceInfo";

const initialState = {
  profile: {},
  returnUrlAfterSlackOrTeamsAuth: null,
  afterLoginRedirect:""
};

export default function(state = initialState, action) {
  let org = { ...state.profile.organizationId };
  let { activity } = state.profile;
  const organization = { ...state.profile.organizationId };

  switch (action.type) {
    case actionTypes.STORY_METRICS_CHANGE:
      // console.log(action.val)
      // return
      if (isMobileDevice) {
        return { ...state, profile: { ...state.profile } };
      } else {
        let { type, value } = action.val;
        console.log(action);

        if (type === "story") {
          let currentStories = activity.stories;
          let newActivity = { ...activity, stories: currentStories + value };
          return {
            ...state,
            profile: { ...state.profile, activity: { ...newActivity } },
          };
        } else if (type === "reactions") {
          let currentReactions = activity.reactions;

          let newActivity = {
            ...activity,
            reactions: currentReactions + value,
          };
          return {
            ...state,
            profile: { ...state.profile, activity: { ...newActivity } },
          };
        } else {
          let currentReplies = activity.replies;
          let newActivity = { ...activity, replies: currentReplies + value };
          return {
            ...state,
            profile: { ...state.profile, activity: { ...newActivity } },
          };
        }
      }

    case actionTypes.ADD_STORY_COUNT:
    // if(!storyCount || storyCount==="null" || storyCount==="undefined" || storyCount===null) storyCount = 0;
    //     storyCount = storyCount +1
    // return {...state, profile : {...state.profile, storyCount}};

    case actionTypes.SUBTRACT_STORY_COUNT:
    // if(!storyCount || storyCount==="null" || storyCount==="undefined" || storyCount===null) storyCount = 0;
    //     console.log(storyCount)
    //     if(storyCount>0){
    //         storyCount =storyCount-1
    //     } else {
    //         storyCount=0
    //     }

    // return {...state, profile : {...state.profile, storyCount}};

    // SET_STORY_ACTIVITY
    case actionTypes.SET_STORY_ACTIVITY:
      return {
        ...state,
        profile: { ...state.profile, activity: { ...action.val } },
      };

    case actionTypes.LOGIN_SUCCESS:
      return updateObject(state, { profile: action.val });
    case actionTypes.UPDATE_USER_SUCCESS:
      // return updateObject(state, { profile: action.val });

      console.log('state----', state)
      const token = state.profile.autherizationToken;
      let payload = { ...action.val, autherizationToken: token };
      // console.log('val --- ', action.val)
      if (action.val === "logout") {
        payload = {};
        return payload;
      }

      console.log("payload Reducer--- ", payload);
      // console.log('payload Reducer--- ', payload)

      let user_updated = updateObject(
        { state, ...payload },
        { profile: { ...state.profile, ...payload } }
      );
      // let user_updated = updateObject(state, ...payload);

      console.log("user_updated --- ", user_updated);
      return user_updated;
    case actionTypes.UPDATE_PROFILE_INFO_SUCCESS:
      console.log("actions: ", action.val);
      return updateObject(state, {
        profile: { ...state.profile, ...action.val },
      });
    case actionTypes.CHANGE_PASSWORD_SUCCESS:
      return updateObject(state, { profile: {} });
    case actionTypes.RESET_PASSWORD_LINK_SENT:
      break;

    case actionTypes.INDUSTRY_CHANGE_SUCCESS:
      console.log(organization.industry, " ---- action val: ", action.val);
      return {
        ...state,
        profile: {
          ...state.profile,
          organizationId: { ...organization, industry: action.val },
        },
      };
      case actionTypes.ENTERPRISE_NAME_CHANGE_SUCCESS:
        return {
          ...state,
          profile: {
            ...state.profile,
            organizationId: { ...organization, name: action.val },
          },
        };
      break;
    case actionTypes.SKIPPED_ORG_SETUP:
      const org = { ...state.profile.organizationId, ...action.val };
      // console.log(action.val, org)
      // org = action.val;
      return { ...state, profile: { ...state.profile, organizationId: org } };

    // saveUpdatedOffices
    case actionTypes.SAVE_NEW_HIERARCHY:
      // console.log('new names---->')
      // console.log(action, action.val, state)
      let hierarchy = action.val.staticHierarchy;
      let version = action.val.hierarchyVersion;
      let lastUpdate = action.val.lastUpdate;
      let saveNewHier = {
        ...state.profile.organizationId,
        staticHierarchy: hierarchy,
        lastUpdate,
      };
      if (action.val.isTreeDataChanged) {
        saveNewHier.hierarchyVersion = version;
      }

      return {
        ...state,
        profile: { ...state.profile, organizationId: saveNewHier },
      };

    // return {...state, profile : {...state.profile, organizationId: {...state.profile.organizationId, staticHierarchy:action.val }}};

    case actionTypes.ORG_CHANGE_SUCCESS:
      // let org = {...state.profile.organizationId};
      // console.log(action.val, action, org)
      // org.emailDomains = [...org.emailDomains, action.val];

      // console.log(action.val, '---before obj--',state.profile)
      let obj = {
        ...state,
        profile: {
          ...state.profile,
          organizationId: { ...state.profile.organizationId, ...action.val },
        },
      };
      // console.log('afeter----')
      // console.log('obj---', obj)
      // return {...state, profile : {...state.profile,
      //     organizationId :  {...action.val}
      // }};
      return obj;

    case actionTypes.ORG_HIER_CHANGE:
      // let org = {...state.profile.organizationId};
      // console.log(action.val)
      org.staticHierarchy = action.val;
      return { ...state, profile: { ...state.profile, organizationId: org } };

    case actionTypes.ORG_REMOVE_EMAIL:
      let newOrg = { ...state.profile.organizationId };
      // console.log(state.profile)

      // console.log(action,'-----',action.val)
      newOrg.emailDomains = [...action.val];

      return {
        ...state,
        profile: { ...state.profile, organizationId: newOrg },
      };
    case actionTypes.ORG_REMOVE_SLACK_URL:
      let currentOrg = { ...state.profile.organizationId };
      // console.log(state.profile)

      // console.log(action,'-----',action.val)
      currentOrg.allowedSlackWorkspaces = [...action.val];

      return {
        ...state,
        profile: { ...state.profile, organizationId: currentOrg },
      };
    case actionTypes.ORG_REMOVE_TEAMS_TENANT:
      let currentOrgT = { ...state.profile.organizationId };
      currentOrgT.allowedTeamsTenants = [...action.val];

      return {
        ...state,
        profile: { ...state.profile, organizationId: currentOrgT },
      };
    case actionTypes.USER_SET_SLACK_TEAMS_AFTERAUTH_RETURN_URL:
      return { ...state, returnUrlAfterSlackOrTeamsAuth: action.payload };

    case actionTypes.SET_AFTER_LOGIN_REDIRECT:
      return {...state,afterLoginRedirect:action.payload}
    default:
      break;
  }
  return state;
}
